import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import Heading from "@atlaskit/heading";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

const headerStyles = css({
    textAlign: "center",
    paddingBlock: token("space.800"),
    maxWidth: "720px",
    marginInline: "auto"
});

const titleStyles = css({
    fontFamily: wacToken("font.charlie.display")
});

const subtitleStyles = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "18px",
    lineHeight: "28px",
    color: wacToken("color.neutral.light700"),
    marginBlockStart: token("space.200")
});

export const PageHeader = () => {
    return (
        <header css={headerStyles}>
            <Heading size="xlarge" as="h1">
                <span css={titleStyles}>
                    <FormattedMessage {...messages.title} />
                </span>
            </Heading>
            <p css={subtitleStyles}>
                <FormattedMessage {...messages.subtitle} />
            </p>
        </header>
    );
};
